/**
 * Component gut-projects-filter JS
 *
 * !!! Uncomment only if component is needed, this way the compiler will ignore useless files
 */
 
jQuery(document).ready(function () {
    const component = jQuery('.gut-projects-filter');
    
    if (!component.length) {
        return;
    }

    jQuery('.gut-projects-filter__filters a', component).bind('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        jQuery('.gut-projects-filter__filters a', component).removeClass('ll-pill--active');
        jQuery(this).addClass('ll-pill--active');

        const category = jQuery(this).data('category');

        let query = '.ll-' + category;
        console.log(query);

        jQuery('.gut-projects-filtered__items-item').hide();
        jQuery(query).show();

    });

});